import { BrainfishAnalytics as t, default as r } from "./web.js";
(function() {
  try {
    var e = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {}, a = new e.Error().stack;
    a && (e._sentryDebugIds = e._sentryDebugIds || {}, e._sentryDebugIds[a] = "7e7431ab-4824-42cc-8d1a-477faa64f6a0", e._sentryDebugIdIdentifier = "sentry-dbid-7e7431ab-4824-42cc-8d1a-477faa64f6a0");
  } catch (d) {
  }
})();
export {
  t as BrainfishAnalytics,
  r as default
};
//# sourceMappingURL=index.js.map
